import * as React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import type { TaxonomyProjectType } from '../../../../types/uncinc_profile/taxonomy';

interface TaxonomyProjectTypeTeaserProps {
  entity: ImmutableEntity<TaxonomyProjectType>;
}

const TaxonomyProjectTypeTeaser: React.FC<TaxonomyProjectTypeTeaserProps> = ({ entity }) => {
  const theme = entity.toJS();
  const title = theme.name[0].value;
  const body = theme.description[0].value;

  return (
    <div className="TaxonomyProjectTypeTeaser">
      <h1 className="TaxonomyProjectTypeTeaser__title">{title}</h1>
      <WysiwygField html={body} className="TaxonomyProjectTypePage__body" />
    </div>
  );
};

export default TaxonomyProjectTypeTeaser;
